var TabsMenuNav = class extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('button[aria-controls]'));
    this.buttons.forEach((button) => button.addEventListener('click', () => this.selectButton(button)));

    this.addEventListener('shopify:block:select', (event) => this.selectButton(event.target, !event.detail.load));
  }
  get selectedButton() {
    return this.buttons.find((button) => button.getAttribute('aria-expanded') === 'true');
  }
  selectButton(button, animate = true) {
    if (!this.buttons.includes(button) || this.selectedButton === button) {
      return;
    }

    const from = document.getElementById(this.selectedButton.getAttribute('aria-controls'));
    const to = document.getElementById(button.getAttribute('aria-controls'));

    if (animate) {
      this._transitionContent(from, to);
    } else {
      from.hidden = true;
      to.hidden = false;
    }

    this.selectedButton.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-expanded', 'true');

    triggerEvent(this, 'tabs-menu-nav:changed', { button });
  }
  closeAll() {
    //Close all other targets of buttons
    const buttons = this.querySelectorAll('button[aria-expanded]');
    buttons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
  }
  _transitionContent(from, to) {
    from.animate(
      {
        opacity: [1, 0],
      },
      {
        duration: 250,
        easing: 'ease',
      }
    ).onfinish = () => {
      from.hidden = true;
      to.hidden = false;
      to.animate(
        {
          opacity: [0, 1],
        },
        {
          duration: 250,
          easing: 'ease',
        }
      );
    };
  }
};
window.customElements.define('tabs-menu-nav', TabsMenuNav);

var TabsButton = class extends HTMLButtonElement {
  static get observedAttributes() {
    return ['aria-expanded', 'aria-busy'];
  }
  constructor() {
    super();
    this.addEventListener('click', this._onButtonClick.bind(this));
    this.rootDelegate = new main_default(document.documentElement);
  }
  _onButtonClick() {
    if (this.hasDrawerControls) {
      this.drawerElement.open = true;
    }
    this.isExpanded = !this.isExpanded;
  }
  connectedCallback() {
    document.addEventListener('tabs-menu-nav:changed', (event) => {
      this.closeAll();
    });

    document.addEventListener('openable-element:close', (event) => {
      this.closeAll();
      this.closeMenu();
    });

    document.addEventListener('openable-element:open', (event) => {
      if (this.controlledElement === event.target) {
        this.isExpanded = true;
        event.stopPropagation();
      }
    });

    this.rootDelegate.on("openable-element:load:start", `#${this.getAttribute("aria-controls")}`, () => {
      if (this.classList.contains("button")) {
        this.setAttribute("aria-busy", "true");
      } else if (this.offsetParent !== null) {
        triggerEvent(document.documentElement, "theme:loading:start");
      }
    }, true);

    this.rootDelegate.on("openable-element:load:end", `#${this.getAttribute("aria-controls")}`, () => {
      if (this.classList.contains("button")) {
        this.removeAttribute("aria-busy");
      } else if (this.offsetParent !== null) {
        triggerEvent(document.documentElement, "theme:loading:end");
      }
    }, true);
  }
  disconnectedCallback() {
    this.rootDelegate.destroy();
  }
  get isExpanded() {
    return this.getAttribute('aria-expanded') === 'true';
  }
  set isExpanded(value) {
    this.setAttribute('aria-expanded', value === true ? 'true' : 'false');
  }
  get hasDrawerControls() {
    return this.getAttribute('aria-drawer-controls');
  }
  get controlledElement() {
    return document.getElementById(this.getAttribute('aria-controls'));
  }
  get drawerElement() {
    return document.getElementById(this.getAttribute('aria-drawer-controls'));
  }
  get otherControlElements() {
    return document.querySelectorAll(`[aria-controls="${this.getAttribute('aria-controls')}"]`);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'aria-expanded':
        if (oldValue === 'false' && newValue === 'true') {
          console.log(this.controlledElement);
          this.controlledElement.removeAttribute('hidden');
          this.controlledElement.setAttribute('aria-expanded', 'true');
          this.otherControlElements.forEach((control) => control.setAttribute('aria-expanded', 'true'));
        } else if (oldValue === 'true' && newValue === 'false') {
          this.controlledElement.setAttribute('hidden', true);
          this.controlledElement.setAttribute('aria-expanded', 'false');
          this.otherControlElements.forEach((control) => control.setAttribute('aria-expanded', 'false'));
        }
        break;
      case 'aria-busy':
        if (this.hasAttribute('loader')) {
          if (newValue === 'true') {
            this._startTransition();
          } else {
            this._endTransition();
          }
        }
        break;
    }
  }
  closeAll() {
    //Close all other targets of buttons
    const buttons = document.querySelectorAll('[is="tabs-button"],tabs-button');
    buttons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
  }
  closeMenu() {
    const buttons = document.querySelectorAll('tabs-menu-nav button');
    buttons.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');

      const target = document.getElementById(button.getAttribute('aria-controls'));
      if (target) {
        target.setAttribute('hidden', true);
      }
    });
  }
};
Object.assign(TabsButton.prototype, LoaderButtonMixin);
window.customElements.define('tabs-button', TabsButton, { extends: 'button' });

// Create a class for the element
class TabsMenu extends HTMLElement {
  static observedAttributes = ['aria-expanded'];

  constructor() {
    super();

    this.buttons = Array.from(this.querySelectorAll('button[is="tabs-button"]'));
    this.buttons.forEach((button) => button.addEventListener('click', (e) => this._onButtonClick(e, button)));
  }
  attributeChangedCallback(name, oldValue, newValue) {}

  connectedCallback() {}

  _onButtonClick(event, target) {
    event.preventDefault();

    const targets = this.buttons.filter(button => button !== target);
    targets.forEach(target => target.setAttribute('aria-expanded', 'false'));
  }
}
window.customElements.define('tabs-menu', TabsMenu);
